export const CATEGORY_KEYS = {
    base: 'categories',
    all: ['categories'],
    list: ['categories', 'list'],
    detail: (id: string) => ['categories', 'detail', id]
} as const;
